import React, {useState, useEffect} from "react";
import Profile from "./Profile"
import {connect} from "react-redux";
import { changePassword, editUser } from '../../redux';

function ProfileContainer (props) {
    const {
        user,
        changePassword,
        editUser,
        authErrCode,
    } = props;

    const [email, setEmail] = useState("");
    const [firstName, setFirstName] = useState("");
    const [lastName, setLastName] = useState("");
    const [studentId, setStudentId] = useState("");
    const [newPassword, setNewPassword] = useState("");
    const [newPasswordRepeat, setNewPasswordRepeat] = useState("");
    const [message, setMessage] = useState("");
    const [passwordMsg, setPasswordMsg] = useState("");

    useEffect(() => {
        setEmail(user.email);
        setFirstName(user.firstName);
        setLastName(user.lastName);
        setStudentId(user.studentId);
    }, [])

    const handleChange = (e) => {
        const fieldName = e.target.name;

        const stateSetter = 
            fieldName === "email" ? setEmail :
            fieldName === "firstName" ? setFirstName :
            fieldName === "lastName" ? setLastName :
            fieldName === "studentId" ? setStudentId :
            fieldName === "newPassword" ? setNewPassword :
            fieldName === "newPasswordRepeat" ? setNewPasswordRepeat : 
            null;

        stateSetter(e.target.value);
    }

    const handlePasswordSubmit = (e) => {
        e.preventDefault();
        if (newPassword === newPasswordRepeat) {
            changePassword(newPassword);

            setPasswordMsg("Your password was successfully changed.");
            setNewPassword("");
            setNewPasswordRepeat("");
            setMessage("");
        } else {
            setPasswordMsg("Passwords did not match.");
            setNewPassword("");
            setNewPasswordRepeat("");
            setMessage("");
        }
    }

    const handleEdit = (e) => {
        e.preventDefault();

        if (user.type !== "student") {
            editUser({email, firstName, lastName});
        } else {
            editUser({email, firstName, lastName, studentId});
        }

        setMessage("Your profile was successfully changed.");
        setPasswordMsg("");
    }

    return (
        <Profile
            email={email}
            firstName={firstName}
            lastName={lastName}
            studentId={studentId}
            newPassword={newPassword}
            newPasswordRepeat={newPasswordRepeat}
            handleChange={handleChange}
            handleEdit={handleEdit}
            handlePasswordSubmit={handlePasswordSubmit}
            message={authErrCode.edit > 499 ? "Server error!" : message}
            passwordMsg={passwordMsg}
            isStudent={user.type}/>
    )
}

export default connect(state => state.root, { changePassword, editUser })(ProfileContainer);
